import { filterDate_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDate_template";
import { filterListingPage_template } from "./filterListingPage_template";
import { filterPreset_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterPreset_template";
import { filterSimple_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import { multipleSelector_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import { pagination_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import { resultsInfo_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";
import { filterDropdown_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template";
import { vnTemplate } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import { filterWebsiteUser_template } from "./filterWebsiteUser_template";
import { validationsList_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";
import {infoButton_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/infoButton_template";
import { array } from "@amcharts/amcharts4/core";

declare const ko: any;

const DATE_FORMAT = "YYYY-MM-DD HH:mm:ss";

export class threadSuggestionsList_template extends vnTemplate {
    public validationsListTemplate: validationsList_template;
    protected filterArticleStatus: multipleSelector_template;
    protected filterBrand: filterDropdown_template;
    protected filterContainsImages: multipleSelector_template;
    protected filterContainsLink: multipleSelector_template;
    protected filterDate: filterDate_template;
    protected filterIsPremium: multipleSelector_template;
    protected filterPreset: filterPreset_template;
    protected filterSimple: filterSimple_template;
    protected filterStatus: multipleSelector_template;
    protected filterListingPage: filterListingPage_template;
    protected filterWebsiteUser: filterWebsiteUser_template;
    protected itemsPerPageFilter: filterDropdown_template;
    protected pagination: pagination_template;
    protected resultInfos: resultsInfo_template;
    protected threadStatusTooltip: infoButton_template;
    protected sendNotificationTooltip: infoButton_template;
    protected getTemplateHtml(): string {
        return /*html*/ `
            <div id="list-references">
                <div class="sub-header filter-preset w-justify ">
                    ${this.filterPreset.getHtmlBuild()}
                </div>

                <div class="sub-header w-justify">
                    <div class="w-left">
                         <div class="form-group">
                            <label class="form-label form-label-box">Brand</label>
                            ${this.filterBrand.getHtmlBuild()}
                        </div>
                        ${this.filterStatus.getHtmlBuild()}
                        ${this.filterArticleStatus.getHtmlBuild()}
                        ${this.filterContainsImages.getHtmlBuild()}
                        ${this.filterContainsLink.getHtmlBuild()}
                        ${this.filterIsPremium.getHtmlBuild()}
                        ${this.filterWebsiteUser.getHtmlBuild()}
                        ${this.filterListingPage.getHtmlBuild()}
                        ${this.filterDate.getHtmlBuild()}
                    </div>
                </div>
            </div>

            <div class="w-filters-selected">
                <div id="filters-selected" class="filters-selected">
                    <div id="selected-brands"></div>
                    <div id="selected-is-active"></div>
                    <div id="selected-is-premium"></div>
                    <div id="selected-article-status"></div>
                    <div id="selected-contains-images"></div>
                    <div id="selected-contains-link"></div>
                    <div id="selected-website-users"></div>
                    <div id="selected-date"></div>
                    <div id="selected-listing-page"></div>
                </div>
            </div>

            <div class="list-header w-justify" >
                <div class="w-left">
                    <button class="btn" style="position: relative" data-bind="event:{ click: onDynamicButtonClick}">
                    <!-- ko if: awaitingPublication() == 0 -->
                    <span class="button-number-result result-null" style="margin-right: 8px;" data-bind="html: awaitingPublication"></span>
                    <!-- /ko -->
                    <!-- ko if: awaitingPublication() > 0 -->
                    <span class="button-number-result" style="margin-right: 8px;" data-bind="html: awaitingPublication"></span>
                    <!-- /ko -->

                    Awaiting Publication
                    </button>
                </div>
                <div class="w-center">
                    ${this.filterSimple.getHtmlBuild()}
                </div>
                <div class="w-right">
                    <div>
                    <label class="form-label form-label-box">Rows</label>
                        ${this.itemsPerPageFilter.getHtmlBuild()}
                    </div>
                    ${this.pagination.getHtmlBuild()}
                </div>
            </div>

            <div class="w-list-results" id="list-results">
                <table class="list-results">
                    ${this.resultInfos.getHtmlBuild()}
                    <thead>
                        <tr>
                            <th><span class="icon" >Edit</span></th>
                            <!-- ko if: hasBrand -->
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'idAccessPoint') }, css: { 'list-sort-desc': orderByAndDirection()=='idAccessPoint_DESC', 'list-sort-asc': orderByAndDirection()=='idAccessPoint_ASC' }">Brand</span></th>
                            <!-- /ko -->
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'title') }, css: { 'list-sort-desc': orderByAndDirection()=='title_DESC', 'list-sort-asc': orderByAndDirection()=='title_ASC' }">Title</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'content') }, css: { 'list-sort-desc': orderByAndDirection()=='content_DESC', 'list-sort-asc': orderByAndDirection()=='content_ASC' }">Content</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'link') }, css: { 'list-sort-desc': orderByAndDirection()=='link_DESC', 'list-sort-asc': orderByAndDirection()=='link_ASC' }">Has Link</span></th>
                            <th><span class="icon list-sort-none">Image</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'idListingPage') }, css: { 'list-sort-desc': orderByAndDirection()=='idListingPage_DESC', 'list-sort-asc': orderByAndDirection()=='idListingPage_ASC' }">Listing Page</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'status') }, css: { 'list-sort-desc': orderByAndDirection()=='status_DESC', 'list-sort-asc': orderByAndDirection()=='status_ASC' }">Status</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'rejectionReason') }, css: { 'list-sort-desc': orderByAndDirection()=='rejectionReason_DESC', 'list-sort-asc': orderByAndDirection()=='rejectionReason_ASC' }">Rejection Reason</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'article') }, css: { 'list-sort-desc': orderByAndDirection()=='article_DESC', 'list-sort-asc': orderByAndDirection()=='article_ASC' }">Article</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'articleStatus') }, css: { 'list-sort-desc': orderByAndDirection()=='articleStatus_DESC', 'list-sort-asc': orderByAndDirection()=='articleStatus_ASC' }">Article Status</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'idAccessPointUser') }, css: { 'list-sort-desc': orderByAndDirection()=='idAccessPointUser_DESC', 'list-sort-asc': orderByAndDirection()=='idAccessPointUser_ASC' }">Website User</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'moderator') }, css: { 'list-sort-desc': orderByAndDirection()=='moderator_DESC', 'list-sort-asc': orderByAndDirection()=='moderator_ASC' }">Moderator</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateCreated') }, css: { 'list-sort-desc': orderByAndDirection()=='dateCreated_DESC', 'list-sort-asc': orderByAndDirection()=='dateCreated_ASC' }">Submitted</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateUpdated') }, css: { 'list-sort-desc': orderByAndDirection()=='dateUpdated_DESC', 'list-sort-asc': orderByAndDirection()=='dateUpdated_ASC' }">Updated</span></th>
                            <th class="align-right"><span>Delete</span></th>
                        </tr>
                    </thead>
                    <tbody data-bind="foreach: threadSuggestions">
                        <tr>
                            <td class="align-center">
                                <button class="btn border only-icon icon border i-edit" type="button"  data-bind="event: { click: $parent.onClickShowPopUp }, clickBubble: false">
                                    <span class="hidden-text">Edit</span>
                                </button>
                            </td>

                            <!-- ko if: $parent.hasBrand -->
                                <td class="brands"><a><span class="dark" data-bind="css: brandIconImage"></span></a></td>
                            <!-- /ko -->
                            <td><span class="thread-form-title-table" data-bind="text: title" style="word-break: break-word;"></span></td>
                            <td><span class="t-thread-suggestion" data-bind="html: content" style="word-break: break-word;"></span></td>
                            <td>
                                <span class="icon" data-bind="text: link, css: { 'has-link i-check': !!hasLink, 'no-link i-cross': !hasLink}"><span/>
                            </td>
                            <td>
                                <!-- ko if: imageUrl != null -->
                                    <img alt="" class="thread-suggestion-upload" data-bind="attr: { src: imageUrl }"/>
                                <!-- /ko -->
                            </td>
                            <td><span data-bind="text: listingPage"></span></td>
                            <td><span data-bind="text: status"></span></td>
                            <td><span class="t-thread-rejection" data-bind="text: rejectionReason"></span></td>
                            <td class="align-center">
                                <!-- ko if: article -->
                                    <button class="btn border only-icon icon border highlight i-article" type="button" data-bind="click: $parent.onEditArticle">
                                        <span class="hidden-text">Edit Article</span>
                                    </button>
                                <!-- /ko -->
                            </td>
                            <td><span data-bind="text: articleStatus"></span></td>
                            <td>
                                <div style="display: flex; gap: .5rem; align-items: center">
                                    <button class="btn border only-icon icon border highlight i-user" type="button" data-bind="click: $parent.onClickViewWebsiteUser">
                                        <span class="hidden-text">View Author</span>
                                    </button>
                                    <div class="flex user" data-bind="css: {'premium-user': isAnyPremium}">
                                        <p data-bind="text: websiteUser, css: {'user': isWebsiteUserActive, 'user-deactivated': !isWebsiteUserActive}"></p>
                                        <!-- ko if: isAnyPremium -->
                                        <img class="premium-indic" src="../assets/images/premuim-indic.svg" alt="premium indicator">
                                        <!-- /ko -->  
                                    </div>  
                                </div>
                            </td>
                            <td><span data-bind="text: moderator"></span></td>
                            <td><span data-bind="text: dateCreated"></span></td>
                            <td><span data-bind="text: dateUpdated"></span></td>
                            <td class="align-center">
                                <button class="btn border only-icon icon border highlight i-delete" type="button" data-bind="click: $parent.onClickDelete, attr: { disabled: rawData.idStatus == 2 }">
                                    <span class="hidden-text">Delete</span>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
<!-- ------------------------------------------------------------------------------------- -->
            <div id="edit-dialog" class="w-lightbox light-theme" >
                <div class="lightbox-content">
                    <div class="w-form w-form-large lightbox-form" style="width: 100%">
                        <div class="form-header">
                            <h3 class="form-title">Edit Thread Submission</h3>
                            <button type="button"  data-bind="event: { click: onClickHidePopUp }" class="close-button icon i-close-2"></button>
                        </div>
                        ${this.validationsListTemplate.getHtmlBuild()}
                        <!-- ko if: threadToEdit() != null -->
                        <div class="w-form-body" style="max-height: 400px; overflow-y: scroll;">
                            <div class="form-body" style="padding-top: 0">
                                <strong class="form-sub-title no-margin">Info</strong>
                                <div class="form-group row" style="align-items: flex-start">
                                    <div style="flex: 1;">
                                        <label class="form-label" style=" width: 100%">Brand</label>
                                        <div class="thread-brand-icon" data-bind="css: threadToEdit().brandIconImage"></div>
                                    </div>
                                    <div style="flex: 1;">
                                        <label class="form-label" >Website user</label>
                                        <div class="flex user" data-bind="css: {'user-premium': threadToEdit().isAnyPremium}">
                                            <!-- ko if: threadToEdit().isAnyPremium -->
                                            <img class="premium-indic" src="../assets/images/premuim-indic.svg" alt="premium indicator">
                                            <!-- /ko -->  
                                            <p data-bind="text: threadToEdit().websiteUser, css: {'user-deactivated': !threadToEdit().isWebsiteUserActive}"></p>
                                        </div>  
<!--                                        <p data-bind="text: threadToEdit().websiteUser, css: {'premium': threadToEdit().isAnyPremium, 'user': threadToEdit().isWebsiteUserActive, 'user-deactivated': !threadToEdit().isWebsiteUserActive}"></p>-->
                                    </div>
                                </div>
                            </div>
                            
                            <div class="form-body section-content full-width" style="padding-top: 0">
                                <strong class="form-sub-title no-margin">Content</strong>
                                <div class="form-group" style="display: flex; flex-direction: column;">
                                    <label class="form-label" >Title</label>
                                    <span><p style="font-weight: bold" data-bind="text: threadToEdit().title"></p></span>
                                </div>
                                <div class="form-group" style="display: flex; flex-direction: column;">
                                    <label class="form-label" >Content</label>
                                    <span data-bind="html: threadToEdit().content">
                                </div>
                            </div>
                            <div class="form-body">
                                <div class="form-group" style="display: flex; flex-direction: column;">
                                    <label class="form-label" style=" width: 100%">Link</label>
                                    <!-- ko if: threadToEdit().rawData.link -->
                                        <a class="icon i-link" style="display: flex; align-items: center; gap: .5rem;" target="_blank" data-bind="attr: {href: threadToEdit().rawData.link}">
                                            <p data-bind="text: threadToEdit().rawData.link"> none</p>
                                        </a>
                                    <!-- /ko -->
                                    <!-- ko if: !threadToEdit().rawData.link -->
                                        <p class="icon i-link"> none</p>
                                    <!-- /ko -->
                                </div>
                                <div class="form-group">
                                    <label class="form-label" style=" width: 100%">Listing Page</label>
                                    <p data-bind="text: threadToEdit().listingPage"></p>
                                </div>
                               </div>
                            <div class="form-body">
                                <div class="form-group" style="display: flex; flex-direction: column;">
                                    <label class="form-label" >Image</label>
                                    <!-- ko if: threadToEdit().imageUrl -->
                                        <img style="width:100%; max-width: 320px;" data-bind="attr: {src: threadToEdit().imageUrl}" alt="thread image"/>
                                    <!-- /ko -->
                                    <!-- ko if: !threadToEdit().imageUrl -->
                                        <p>none</p>
                                    <!-- /ko -->
                                </div>
                            </div>
                        </div>
                        <div class="w-form-body">
                            <strong class="form-sub-title no-margin" style="margin: 0;">Status</strong>
                            <div class="form-body">
                                <div class="form-group row">
                                    <label class="form-label flex-none" style="display: flex; margin: 0;">
                                        Status
                                        <div class="w-tooltips-adv pos-top short"> ${this.threadStatusTooltip.getHtmlBuild()} </div>
                                    </label>
                                    <div class="form-thread-status">
                                        <select style="width: 100%;" data-bind="event: { change: onFormUpdate }, attr: {disabled: idEditStatusDisabled()}, value: idEditStatus, options: statusOptions, optionsText: 'name', optionsValue: 'id'"></select>
                                    </div>
                                </div> 
                                <div class="form-group row" style="width: fit-content">
                                    <input type="checkbox" id="send-notification" name="send-notification" data-bind="checked: sendNotification, attr: { disabled: sendNotificationDisabled()}">
                                    <label for="send-notification" style="padding-block:0;"  class="form-label icon i-check">Send Notification to Website User</label>
                                    <div class="w-tooltips-adv pos-top short"> ${this.sendNotificationTooltip.getHtmlBuild()} </div>
                                </div>
                                <!-- ko if: threadToEdit().dateNotificationSent -->
                                    <div class="form-group">
                                        <label class="form-label">
                                            Date Notification Sent
                                        </label>
                                        <p data-bind="text: threadToEdit().dateNotificationSent"></p>
                                    </div>
                                <!-- /ko -->
                            </div> 
                            <div class="form-body">
                                <!-- ko if: idEditStatus() == 3 -->
                                    <div class="form-group row">
                                        <label class="form-label" style="display: flex; margin: 0;">
                                           Rejection Reason 
                                            <!-- <div class="w-tooltips-adv pos-right short"> ${this.threadStatusTooltip.getHtmlBuild()} </div> -->
                                        </label>
                                        <div class="form-thread-status">
                                            <select style="width: 100%" data-bind="event: { change: onFormUpdate }, attr: {disabled: idRejectionReasonDisabled()}, value: idRejectionReason, options: rejectionReasonOptions, optionsText: 'name', optionsValue: 'id'"></select>
                                        </div>
                                    </div> 
                                    <!-- ko if: idRejectionReason() == 1 -->
                                        <div class="form-group">
                                            <div class="form-thread-status">
                                                <textarea style="width: 100%; resize: none; height: 10rem;" data-bind="event: { change: onFormUpdate }, attr: {disabled: rejectionMessageDisabled()}, value: rejectionMessage"></textarea>
                                            </div>
                                        </div>
                                    <!-- /ko -->
                                <!-- /ko -->
                                <!-- ko if: idEditStatus() == 2 && !threadToEdit().rawData.idArticle && threadToEdit().rawData.idStatus != 2-->
                                    <div class="form-group row" style="width: fit-content">
                                        <input type="checkbox" id="create-article-upon-approval" name="create-article-upon-approval" data-bind="checked: createArticleUponApproval">
                                        <label for="create-article-upon-approval" style="padding-block:0;"  class="form-label icon i-check">Create article upon saving</label>
                                    </div>
                                <!-- /ko -->
                                <!-- ko if: idEditStatus() == 2 && !threadToEdit().rawData.idArticle && threadToEdit().rawData.idStatus == 2 -->
                                    <div class="form-group row" >
                                        <button type="button" data-bind="event: { click: onCreateArticle }" class="btn highlight">Create Article</button>
                                    </div>
                                <!-- /ko -->
                                <!-- ko if: threadToEdit().rawData.article -->
                                    <div class="form-group" >
                                        <label class="form-label" >Article Status</label>
                                        <p data-bind="html: threadToEdit().articleStatus"></p>
                                    </div>    
                                <!-- /ko -->
                                <!-- ko if: threadToEdit().rawData.idArticle -->
                                    <div class="form-group row">
                                        <button type="button" data-bind="event: { click: onEditArticle }" class="btn highlight">Edit Article</button>
                                    </div>
                                <!-- /ko -->
                            </div>
                        </div>
                        <!-- /ko -->
                        <div class="form-footer">
                            <button type="button" data-bind="event: { click: onClickHidePopUp }" class="btn">Cancel</button>
                            <button type="button" data-bind="attr: {disabled: saveDisabled()}, event: { click: onClickSave }" class="btn highlight">Save</button>
                        </div>
                    </div>

                </div>
            </div>
            `;
    }

    protected getTemplateName(): string {
        return "threadSuggestionsList_template";
    }

    protected getMainElementClasses(): Array<string> {
        return ["w-content"];
    }

    protected getMainElementType(): string {
        return "div";
    }

    // region init partial
    protected initPartial(): void {
        this.validationsListTemplate = new validationsList_template('validations', this.getTemplateViewModel(), this.caller);
        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.resultInfos = new resultsInfo_template("resultInfo", this.getTemplateViewModel(), this.caller);

        this.filterPreset = new filterPreset_template("filterPreset", this.getTemplateViewModel(), this.caller);
        this.filterPreset.getTemplateViewModel().searchPresetType("thread_suggestions");

        let threadStatusTooltipText = `
        <ul>
            <li>Threads with the "Submitted" and "Pending Review"</li>
            <li>Approved threads are visible publicly on the website.</li>
            <li>Rejected threads are not visible publicly on the website.</li>
        </ul>`;
        this.threadStatusTooltip = new infoButton_template('threadStatusTooltip', this.getTemplateViewModel(), this.caller)
        this.threadStatusTooltip.setTitle('Thread Status');
        this.threadStatusTooltip.setContent(threadStatusTooltipText);
        let sendNotificationTooltipText = `
        <ul>
            <li>
                <span>Upon selecting a status, the option to send the relevant notification to the website user becomes optional.</span>
                <ul>
                    <li>Rejected suggestions will send notifications on save. The notification will include the rejection reason.</li>
                    <li>Approved suggestions will send notifications when the associated article is first published. The notification will include the associated article.</li>
                </ul>
            </li>
        </ul>`;
        this.sendNotificationTooltip = new infoButton_template('sendNotificationTooltip', this.getTemplateViewModel(), this.caller)
        this.sendNotificationTooltip.setTitle('Send Notification to Website User');
        this.sendNotificationTooltip.setContent(sendNotificationTooltipText);

        this.filterBrand = new filterDropdown_template("filterBrand", this.getTemplateViewModel(), this.caller);
        this.filterBrand.setLabel("Brands");

        //NOT SUPPORTED TAG CONTAINER
        this.filterListingPage = new filterListingPage_template("filterListingPage", this.getTemplateViewModel(), this.caller);
        this.filterListingPage.setTagContainerId('selected-listing-page');
        this.filterListingPage.setTagContainerCaption('Selected Listing Page:');

        this.filterDate = new filterDate_template("dateFilter", this.getTemplateViewModel(), this.caller);
        this.filterDate.getTemplateViewModel().startDate(null);
        this.filterDate.getTemplateViewModel().endDate(null);
        this.filterDate.toggleClearButton(true);
        this.filterDate.setLabel("Date Range");

        this.filterSimple = new filterSimple_template("filter", this.getTemplateViewModel(), this.caller);

        this.itemsPerPageFilter = new filterDropdown_template("itemsPerPageFilter", this.getTemplateViewModel(), this.caller);
        this.itemsPerPageFilter.setOptions([
            { id: 25, name: '25' },
            { id: 50, name: '50' },
            { id: 100, name: '100' },
        ]);

        this.filterIsPremium = new multipleSelector_template("filterIsPremium", this.getTemplateViewModel(), this.caller);
        this.filterIsPremium.setLabel("Is Website User Premium");
        this.filterIsPremium.setFilterContainerClass('margin-neg');
        this.filterIsPremium.setTagContainerId('selected-is-premium');
        this.filterIsPremium.setTagContainerCaption('Is Website User Premium:');
        this.filterIsPremium.setItems([
            {id: 1, name: 'Paid'},
            {id: 2, name: 'Free'},
            {id: 3, name: 'No'}
        ]);

        this.filterContainsImages = new multipleSelector_template("filterContainsImages", this.getTemplateViewModel(), this.caller);
        this.filterContainsImages.setLabel("Contains Images");
        this.filterContainsImages.setFilterContainerClass('margin-neg');
        this.filterContainsImages.setTagContainerId('selected-contains-images');
        this.filterContainsImages.setTagContainerCaption('Contains Images:');
        this.filterContainsImages.setItems([
            {id: 0, name: 'No'},
            {id: 1, name: 'Yes'},
        ]);

        this.filterContainsLink = new multipleSelector_template("filterContainsLink", this.getTemplateViewModel(), this.caller);
        this.filterContainsLink.setLabel("Contains Link");
        this.filterContainsLink.setFilterContainerClass('margin-neg');
        this.filterContainsLink.setTagContainerId('selected-contains-link');
        this.filterContainsLink.setTagContainerCaption('Contains Link:');
        this.filterContainsLink.setItems([
            {id: 0, name: 'No'},
            {id: 1, name: 'Yes'},
        ]);

        this.filterWebsiteUser = new filterWebsiteUser_template("filterWebsiteUser", this.getTemplateViewModel(), this.caller);
        this.filterWebsiteUser.asMultipleSelectionMode();
        this.filterWebsiteUser.setTagContainerId("selected-website-users");
        this.filterWebsiteUser.setTagContainerCaption("Selected website users:");
        this.filterWebsiteUser.setPlaceholderText("Website User");
        this.filterWebsiteUser.setUniqueIdentifier("userId");

        this.filterStatus = new multipleSelector_template("filterStatus", this.getTemplateViewModel(), this.caller);
        this.filterStatus.setLabel("Status");
        this.filterStatus.setFilterContainerClass('margin-neg');
        this.filterStatus.setTagContainerId('selected-is-active');
        this.filterStatus.setTagContainerCaption('Status:');

        this.filterArticleStatus = new multipleSelector_template("filterArticleStatus", this.getTemplateViewModel(), this.caller);
        this.filterArticleStatus.setLabel("Article Status");
        this.filterArticleStatus.setFilterContainerClass('margin-neg');
        this.filterArticleStatus.setTagContainerId('selected-article-status');
        this.filterArticleStatus.setTagContainerCaption('Article Status:');

    }

    // endregion

    // region VM->Build
    protected buildViewModel(): any {
        let self = this;
        return {
            awaitingPublication: ko.observable(0),
            hasBrand: ko.observable(true),
            idBrand: ko.observable(null),
            orderBy: ko.observable("dateCreated"),
            orderByAndDirection: ko.observable("dateCreated_DESC"),
            orderByDirection: ko.observable("DESC"),
            permissions: ko.observableArray(this.initPermissions(["article_list_self", "article_list_brand"])),
            threadSuggestions: ko.observableArray([]),
            threadToEdit: ko.observable(null),
            idEditStatus: ko.observable(null),
            idEditStatusDisabled: ko.observable(false),
            sendNotification: ko.observable(false),
            sendNotificationDisabled: ko.observable(false),
            statusOptions: ko.observableArray([]),
            showBrandColumn: ko.observable(false),
            rejectionReasonOptions: ko.observableArray([]),
            idRejectionReason: ko.observable(null),
            idRejectionReasonDisabled: ko.observable(false),
            createArticleUponApproval: ko.observable(true),
            rejectionMessage: ko.observable(""),
            rejectionMessageDisabled: ko.observable(false),
            saveDisabled: ko.observable(false),
            lastState: ko.observable({}),
            onFormUpdate: () => {
                self.onFormUpdate();
            },
            onClickSave: () => {
                self.onClickSave();
            },
            onClickAdd: () => {
                self.onClickAdd();
            },
            onClickReorder: (value, data, event) => {
                self.onClickReorder(value, data, event);
            },
            onClickView: (data, event) => {
                self.onClickView(data, event);
            },
            onClickViewWebsiteUser:(data, event)=> {
                self.onClickViewWebsiteUser(data,event);
            },
            onClickDelete: (data, event) => {
                self.onClickDelete(data, event);
            },
            onClickShowPopUp : (data, event) =>{
                self.onClickShowPopUp(data)
            },
            onClickHidePopUp : (data, event) =>{
                self.onClickHidePopUp()
            },
            onCreateArticle: (data, event) => {
                self.onCreateArticle(data, event);
            },
            onEditArticle: (data, event) => {
                self.onEditArticle(data, event);
            },
            onSearchAction: (data, event) => {
               self.onSearchAction(data,event); 
            },
            onDynamicButtonClick: (data, event) => {
                self.onDynamicButtonClick(data, event);
            }
        };
    }
    // endregion
    // region popup show/hide
    public onClickShowPopUp(data){
        let clone = JSON.parse (JSON.stringify(data));
        let t = this.getTemplateViewModel();
        t.lastState({});
        t.idEditStatusDisabled(false);
        t.idRejectionReasonDisabled(false);
        t.rejectionMessageDisabled(false);
        t.sendNotificationDisabled(false);
        t.threadToEdit(data);
        t.idEditStatus(data.rawData.idStatus);
        t.idRejectionReason(data.rawData.idRejectionReason);
        t.rejectionMessage(data.rawData.rejectionMessage);
        t.sendNotification(data.rawData.sendNotification);
        t.createArticleUponApproval(true);
        this.updateForm(true);
        this.toggleEditDialogVisibility();
    }

    public onClickHidePopUp(){
        let t = this.getTemplateViewModel();
        this.validationsListTemplate.clearMessages();
        t.lastState({});
        t.saveDisabled(false);
        t.threadToEdit(null);
        t.idEditStatus(null);
        t.idRejectionReason(null);
        t.rejectionMessage("");
        t.sendNotification(false);
        t.createArticleUponApproval(true);
        t.idEditStatusDisabled(false);
        t.idRejectionReasonDisabled(false);
        t.rejectionMessageDisabled(false);
        t.sendNotificationDisabled(false);
        this.toggleEditDialogVisibility();
    }
    // endregion

    public toggleEditDialogVisibility() {
        document.getElementById('edit-dialog').classList.toggle('is-visible');
    }
    // region GetVM->Request
    public getViewModelForRequest() {
        this.pagination.getTemplateViewModel().itemPerPage = this.getItemsPerPageSelectedOption().id;
        let status = this.getTemplateViewModel().filterStatus.selectedItems();
        let isPremium = this.getTemplateViewModel().filterIsPremium.selectedItems();
        let containsImages = this.getTemplateViewModel().filterContainsImages.selectedItems();
        let containsLink = this.getTemplateViewModel().filterContainsLink.selectedItems();
        let articleStatus = this.getTemplateViewModel().filterArticleStatus.selectedItems();
        let brand = this.getTemplateViewModel().filterBrand.selectedOption();

        return {
            filters: {
                dateFilterType: this.getTemplateViewModel().dateFilter.selectedFilter(),
                startDate: this.getTemplateViewModel().dateFilter.startDate(),
                startDateRange: this.getTemplateViewModel().dateFilter.fromRange(),
                endDate: this.getTemplateViewModel().dateFilter.endDate(),
                endDateRange: this.getTemplateViewModel().dateFilter.toRange(),
                keywords: this.getTemplateViewModel().filter.filterKeyword,
                itemsPerPage: this.getTemplateViewModel().pagination.itemPerPage,
                idListingPage: this.getTemplateViewModel().filterListingPage.idListingPage(),
                users: this.filterWebsiteUser.getUsersForRequest(),
                isPremium,
                containsImages,
                containsLink,
                status,
                brand,
                articleStatus
            },
            orderBy: this.getTemplateViewModel().orderBy,
            orderByAndDirection: this.getTemplateViewModel().orderByAndDirection,
            orderByDirection: this.getTemplateViewModel().orderByDirection,
            searchPresetName: this.getTemplateViewModel().filterPreset.searchPresetName(),
            searchPresetType: this.getTemplateViewModel().filterPreset.searchPresetType(),
            pagination: this.getTemplateViewModel().pagination,
        };
    }

    // endregion

    // region GetVM->Save
    public getViewModelForSave(){
        return {
            threadToEdit: this.getTemplateViewModel().threadToEdit().rawData,
            idEditStatus: this.getTemplateViewModel().idEditStatus,
            sendNotification: this.getTemplateViewModel().sendNotification,
            idRejectionReason: this.getTemplateViewModel().idRejectionReason,
            rejectionMessage: this.getTemplateViewModel().rejectionMessage,
            createArticleUponApproval: this.getTemplateViewModel().createArticleUponApproval
        };
    }
    // endregion

    // region SetVM->Request
    public setViewModelFromRequest(urlParams) {
        if (urlParams != null) {
            if (urlParams.itemsPerPage) {
                this.itemsPerPageFilter.setSelectedOption(urlParams.itemsPerPage);
            } else {
                this.itemsPerPageFilter.setSelectedOption(25);
            }

            this.setFilterSelectedItems(this.filterArticleStatus, urlParams.articleStatus);
            this.setFilterSelectedItems(this.filterStatus, urlParams.status);
            this.setFilterSelectedItems(this.filterContainsImages, urlParams.containsImages);
            this.setFilterSelectedItems(this.filterContainsLink, urlParams.containsLink);
            this.setFilterSelectedItems(this.filterIsPremium, urlParams.isPremium);

            if (urlParams.brand) {
                this.filterBrand.setSelectedOption(urlParams.brand);
            }

            if (urlParams.idListingPage) {
                this.filterListingPage.setListingPageId(urlParams.idListingPage);
            }

            if(urlParams.users){
                this.filterWebsiteUser.setSelectedUsersFromRequestParams(urlParams.users);
            } else {
                this.filterWebsiteUser.resetTagContainer();
            }

            if (urlParams.dateFilterType) {
                this.filterDate.getTemplateViewModel().selectedFilter(urlParams.dateFilterType);
            }
            if (urlParams.startDateRange || urlParams.endDateRange) {
                this.filterDate.setRange(urlParams.startDateRange, urlParams.endDateRange);
            }
            if (urlParams.startDate || urlParams.endDate) {
                this.setDateFilters(urlParams.startDate, urlParams.endDate);
            }

            let keywordString = urlParams.keywords;
            if (urlParams.keywords) {
                let string = urlParams.keywords;
                if (typeof string === "number") {
                    string = string.toString();
                }
                keywordString = string.replaceAll("+", " ");
            }
            this.filterSimple.getTemplateViewModel().filterKeyword(keywordString);
        }
    }
    // endregion

    public addCreatedPresetToList(response) {
        this.filterPreset.addCreatedPresetToList(response);
    }

    public buildDatePickerCalendar() {
        this.filterDate.buildCalendar();
    }

    public onClickAdd() {
        this.caller.addPlaylist();
    }

    public onClickReorder(value, data, event) {
        data.orderBy(value);
        if (data.orderByAndDirection().includes(value)) {
            if (data.orderByDirection() == "DESC") {
                data.orderByDirection("ASC");
            } else {
                data.orderByDirection("DESC");
            }
        } else {
            data.orderByDirection("DESC");
        }
        data.orderByAndDirection(value + "_" + data.orderByDirection());
        this.caller.threadSuggestionsListReorder();
    }

    public onClickView(data, event) {
        if (event.target.id.indexOf("site-view") == -1) {
            this.caller.viewPlaylist(data.id);
        }
    }

    protected onClickDelete(data, event) {
        if (data.rawData.idStatus == 2) {
            return;
        }

        if (confirm("Are you sure you want to remove this thread suggestion?") === true) {
            this.caller.delete(data.rawData);
        }
    }

    protected onClickSave() {
        this.caller.save();
    }

    protected onFormUpdate() {
        setTimeout(() => {
            this.updateForm(false);
        }, 0);
    }

    protected updateForm(isFirstView = false) {
        let data = this.getViewModelForSave();
        let threadToEdit = data.threadToEdit;
        let t = this.getTemplateViewModel();
        let lastState = t.lastState();
        let locked = lastState.locked || false;

        if (data.idEditStatus() != 3) {
            t.idRejectionReason(null);
            t.rejectionMessage("");
        }

        if (isFirstView) {
            console.log('HERE YES');
            if (data.idEditStatus() == 3) {
                t.idRejectionReasonDisabled(true);
                t.idEditStatusDisabled(true);
                t.rejectionMessageDisabled(true);
                t.sendNotificationDisabled(true);
                t.saveDisabled(true);
                locked = true;
            } else if (data.idEditStatus() == 2) {
                if (threadToEdit.article != null) {
                    if (threadToEdit.article.publishStatus && threadToEdit.article.publishStatus.id == 3) {
                        t.idEditStatusDisabled(true);
                        t.idRejectionReasonDisabled(true);
                        t.rejectionMessageDisabled(true);
                        t.sendNotificationDisabled(true);
                        t.saveDisabled(true);
                        locked = true;
                    }
                }
            }
        } else if (!lastState.locked) {
            console.log('HERE NO');
            if (data.idEditStatus() == 4 || data.idEditStatus() == 1) {
                t.sendNotification(false);
                t.sendNotificationDisabled(true);
            } else {
                t.sendNotificationDisabled(false);
            }

            if (data.idEditStatus() !== lastState.idEditStatus && data.idEditStatus() == 2 && t.sendNotificationDisabled() == false) {
                t.sendNotification(true);
            }

            if (data.idEditStatus() == 3 && lastState.idRejectionReason != data.idRejectionReason() && t.sendNotificationDisabled() == false) {
                const noEmailStatuses = [2,3];
                if (data.idRejectionReason() == 1 ) {
                    t.sendNotification(true);
                } else if (noEmailStatuses.indexOf(data.idEditStatus()) > -1 ) {
                    t.sendNotification(false);
                }
            }

            if (data.idEditStatus() == 3 && data.idRejectionReason() < 1) {
                t.sendNotificationDisabled(true);
            }
        }

        t.lastState({
            sendNotification: t.sendNotification(),
            idEditStatus: t.idEditStatus(),
            idRejectionReason: t.idRejectionReason(),
            rejectionMessage: t.rejectionMessage(),
            locked: lastState.locked || locked,
        });
    }

    protected onSearchAction(data, event) {
        
    }

    protected onCreateArticle(data, event) {
        this.caller.createArticle(data.rawData);
    }

    protected onEditArticle(data, event) {
        this.caller.editArticle(data.rawData);
    }

    protected onClickViewWebsiteUser(data, event) {
        this.caller.viewWebsiteUser(data);
    }

    protected onDynamicButtonClick(data, event) {
        this.filterStatus.setSelectedItems([{id: 2}]);
        this.filterArticleStatus.setSelectedItems([{id: 0}, {id: 1}, {id: 2}]);
        this.caller.filterList();
    }

    private setDateFilters(startDate, endDate) {
        if (startDate) {
            startDate = new Date(startDate.replace(/-/g, "/"));
        }
        if (endDate) {
            endDate = new Date(endDate.replace(/-/g, "/"));
        }
        this.filterDate.setDateRange(startDate, endDate);
    }

    public setResultInfo(nbResults, nbPages, execTime) {
        this.resultInfos.setExecutionTime(execTime);
        this.resultInfos.setNbResults(nbResults);
        this.resultInfos.setNbPages(nbPages);
    }

    public setSearchPresets(presets) {
        this.filterPreset.setSearchPresets(presets);
    }

    // region item props
    public setThreadSuggestions(threadSuggestions: Array<{}>): void {
        let list = [];

        let statuses = this.getTemplateViewModel().statusOptions();
        let rejectionReasonsArr = this.getTemplateViewModel().rejectionReasonOptions();
        let rejectionReasons = {};
        let keyedStatus = {};

        rejectionReasonsArr.forEach((item: any) => {
            rejectionReasons[item.id] = item.name;
        })
        statuses.forEach((item: any) => {
            keyedStatus[item.id] = item.name;
        });

        threadSuggestions.forEach((item: any) => {
            let dateCreated = "";
            let dateUpdated = "";
            let dateNotificationSent = "";
            let imageUrl = "";
            let websiteUser = "";
            let listingPage = "";
            let brandIconImage = "";
            let status = "Unknown";
            let articleStatus = "";
            let moderator = "";
            let rejectionReason = "";
            let isPremium = false;
            let isPremiumFree = false;
            let isActive = false;

            switch (item.idRejectionReason) {
                case 1:
                    rejectionReason = item.rejectionMessage;
                    break;
                default:
                    rejectionReason = rejectionReasons[item.idRejectionReason] || "";
                    break;
            }

            try {
                articleStatus = item.article.publishStatus.name;
                articleStatus = articleStatus.charAt(0).toUpperCase() + articleStatus.slice(1); 
            } catch(e) {}

            try {
                moderator = item.lastModerator.valnet_user.fullNameAndLogin;
            } catch(e) {}

            if (item.accessPointUser) {
                let apu = item.accessPointUser;
                websiteUser = `${apu.displayName || (`${apu.firstName} ${apu.lastName}`) || (`${apu.email}`)} (#${apu.idProfile})`;
                isPremium = apu.isPremium;
                isPremiumFree = apu.isPremiumFree;
                isActive = apu.isActive;
            }

            if (item.dateCreated) {
                dateCreated = new Date(item.dateCreated.date).toLocaleString();
            }
            if (item.dateUpdated) {
                dateUpdated = new Date(item.dateUpdated.date).toLocaleString();
            }

            if (item.dateNotificationSent) {
                dateNotificationSent = new Date(item.dateNotificationSent.date).toLocaleString();
            }

            if (item.images && item.images.length > 0) {
                imageUrl = item.images[0].url || "";
            }

            if (item.accessPoint && item.accessPoint.brands && item.accessPoint.brands.length > 0) {
                brandIconImage = item.accessPoint.brands[0].iconImage;
            }

            if (item.listingPage) {
                listingPage = item.listingPage.name;
            }

            if (keyedStatus[item.idStatus]) {
                status = keyedStatus[item.idStatus];
            }

            list.push({
                rawData: item,
                id: item.id || "",
                idThread: item.idThread || "",
                title: item.title || "",
                content: item.content || "",
                link: item.link ? '' : '',
                hasLink: item.link ? true : false,
                article: item.article || "",
                status: status,
                isWebsiteUserActive: isActive,
                moderator,
                articleStatus,
                rejectionReason,
                brandIconImage,
                listingPage,
                websiteUser,
                isPremium,
                isPremiumFree,
                isAnyPremium: isPremium || isPremiumFree,
                imageUrl,
                dateCreated,
                dateUpdated,
                dateNotificationSent
            });
        });

        this.getTemplateViewModel().threadSuggestions(list);
    }
    // endregion

    public setIdBrand(idBrand) {
        this.getTemplateViewModel().idBrand(idBrand);
        this.getTemplateViewModel().hasBrand(!(idBrand && idBrand > 0));
    }

    public setFilterSelectedItems(objFilter, urlParams) {
        let splitString = [];

        // Multi select filters.
        if (Array.isArray(urlParams)) {
            urlParams = urlParams.toString();
        }
        if (urlParams) {
            if (typeof urlParams == "string") {
                splitString = urlParams.split(",");
            } else {
                splitString = [urlParams];
            }
            let arrayParam = [];
            let idTagArray = [];
            splitString.forEach((id) => {
                if (!isNaN(Number(id))) {
                    id = Number(id);
                } else {
                    id = id.replaceAll("+", " ");
                }
                arrayParam.push({ id: id });
                idTagArray.push(id);
            });
            objFilter.setSelectedItems(arrayParam);
            objFilter.setTags(idTagArray, objFilter.getItems());
        } else {
            objFilter.setSelectedItems([]);
            objFilter.setTags([], objFilter.getItems());
        }
    }

    protected getItemsPerPageSelectedOption() {
        let itemsPerPage = this.itemsPerPageFilter.getSelectedOption();
        const itemsPerPageFilterOptions = this.itemsPerPageFilter.getOptions();
        if(itemsPerPageFilterOptions.indexOf(itemsPerPage) == -1){
            itemsPerPage = itemsPerPageFilterOptions[0];
        }

        return itemsPerPage;
    }

    public setBrandFilter(items) {
        items.unshift({id: 0, name: "All"});
        this.filterBrand.setOptions(items);
    }

    public setArticleStatusFilter(statuses) {
        let arrayOfOptions = [];

        for (let k in statuses) {
            arrayOfOptions.push({ 
                name: statuses[k], 
                id: +k 
            });
        }

        this.filterArticleStatus.setItems(arrayOfOptions);
    }

    public setUserFilterAutocomplete(users) {
        this.filterWebsiteUser.setUsers(users);
    }
    public setStatuses(statuses){
        const ORDER = [1,4,2,3];
        let arrayOfOptions = [];

        for (let k in statuses) {
            arrayOfOptions.push({ 
                name: statuses[k], 
                id: +k 
            });
        }

        //reorder array based on ORDER
        arrayOfOptions = arrayOfOptions.sort((a, b) => ORDER.indexOf(a.id) - ORDER.indexOf(b.id));

        this.filterStatus.setItems(arrayOfOptions);
        this.getTemplateViewModel().statusOptions(arrayOfOptions);
    }
    public getSelectedBrandOption() {
        return this.filterBrand.getSelectedOption();
    }
    public setShowBrandColumn(showBrandColumn) {
        this.getTemplateViewModel().showBrandColumn(showBrandColumn);
    }

    public setRejectionReasons(reasons) {
        let arrayOfOptions = [];

        for (let k in reasons) {
            arrayOfOptions.push({ 
                name: reasons[k], 
                id: +k 
            });
        }

        this.getTemplateViewModel().rejectionReasonOptions(arrayOfOptions);
    }
    public setFilterListingPagesAutoComplete(listingPages): void {
        this.filterListingPage.setOptions(listingPages);
    }
    public setFilterListingPage(listingPage) {
        this.filterListingPage.setListingPage(listingPage);
    }
    public setAwaitingPublicationCount(count) {
        this.getTemplateViewModel().awaitingPublication(count);
    }
    public handleBrandColumnDisplay() {
        let selectedBrandOption = this.getSelectedBrandOption();
        let showBrandColumn = !(selectedBrandOption && selectedBrandOption.id != 0);
        this.setShowBrandColumn(showBrandColumn);
        this.filterWebsiteUser.setDisabled(showBrandColumn);
        this.filterListingPage.setDisabled(showBrandColumn);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/threadSuggestionsList_template.ts